import React from 'react';
import background from '../../assets/sea_turtle.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoSeaturtle extends React.Component {
  render () {
    return(
  
  <ReusableInfoCard              
    
    tag="OCEANS"
    subtag="ENDANGERED"
    description="Sea Turtles"
    paragraph="Sea turtles balance the oceans' food webs. By grazing, they help maintain seagrass beds, and coral reefs. They also control the jellyfish population, which feed on fish larvae."
    
    background= {background}
    />
  
  
  );
 }
}
export default InfoSeaturtle;
